import { render } from "./LanguageList.vue?vue&type=template&id=7ef4675a"
import script from "./LanguageList.vue?vue&type=script&lang=js"
export * from "./LanguageList.vue?vue&type=script&lang=js"
script.render = render

export default script